import React, { Component } from 'react'
import { withRouter, Link } from 'react-router'
import { connect } from 'react-redux'
import { handleGameClick, handleErrorCode, showErrorMessage, renderGame } from '../GamesPageNewLayout/gameUtils.jsx'
import SignIn from '../../header/SignIn.jsx'
import { FormattedMessage } from 'react-intl'
import { messages } from '../GamesPageNewLayout/messages.js'

class AllGamesPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      games: [],
      isLoading: true,
      showSignIn: false,
      favoriteGames: this.getFavoriteGamesFromStorage() || [],
      page: 1,
      limit: 24,
      hasMoreGames: true,
    }
    this.handleScroll = this.handleScroll.bind(this)
  }

  componentDidMount() {
    this.fetchAllGames(this.state.page)
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  componentDidUpdate(prevProps) {
    const { categoryId } = this.props.params
    if (prevProps.params.categoryId !== categoryId) {
      this.setState({ category: categoryId, page: 1, games: [], hasMoreGames: true }, () => {
        this.fetchAllGames(1)
      })
    }
  }

  handleScroll() {
    const { isLoading, hasMoreGames } = this.state
    if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 50 && !isLoading && hasMoreGames) {
      this.handleLoadMoreGames()
    }
  }

  handleLoadMoreGames = () => {
    this.setState(prevState => {
      const newPage = prevState.page + 1
      this.fetchAllGames(newPage, true)
      return { page: newPage }
    })
  }

  fetchAllGames = async (page = 1, append = false) => {
    const { limit, games } = this.state
    this.setState({ isLoading: true })

    try {
      const offset = (page - 1) * limit
      const response = await fetch(`/api/games/all-games?limit=${limit}&offset=${offset}`)
      const data = await response.json()
      const newGames = data.Items.filter(newGame => !games.some(existingGame => existingGame.Id === newGame.Id))

      this.setState(prevState => ({
        games: append ? [...prevState.games, ...newGames] : newGames,
        isLoading: false,
        hasMoreGames: newGames.length === limit,
      }))
    } catch (error) {
      console.error('Failed to fetch games by category:', error)
      this.setState({ isLoading: false })
    }
  }

  openAuthModal = () => {
    const { user } = this.props
    if (user) {
      alert('Игра не доступна')
    } else {
      this.props.dispatch({ type: 'BEGIN_SIGNIN' })
    }
  }

  handleGameClickWrapper = gameId => {
    const { user } = this.props
    this.setState({ isLoading: true })
    handleGameClick(
      gameId,
      user,
      loading => this.setState({ isLoading: loading }),
      errorCode => handleErrorCode(errorCode, showErrorMessage, () => this.openAuthModal())
    )
  }

  saveFavoriteGamesToStorage = favoriteGames => {
    localStorage.setItem('favoriteGames', JSON.stringify(favoriteGames))
  }

  getFavoriteGamesFromStorage = () => {
    try {
      const favorites = localStorage.getItem('favoriteGames')
      return favorites ? JSON.parse(favorites) : []
    } catch (error) {
      console.error('Failed to parse favorite games from localStorage:', error)
      return []
    }
  }

  addGameToFavorites = gameId => {
    const { favoriteGames, games } = this.state
    const gameToAdd = games.find(game => game.Id === gameId)
    const updatedFavorites = [...favoriteGames, gameToAdd]
    this.setState({ favoriteGames: updatedFavorites }, () => {
      this.saveFavoriteGamesToStorage(updatedFavorites)
    })
  }

  removeGameFromFavorites = gameId => {
    const updatedFavorites = this.state.favoriteGames.filter(game => game.Id !== gameId)
    this.setState({ favoriteGames: updatedFavorites }, () => {
      this.saveFavoriteGamesToStorage(updatedFavorites)
    })
  }

  pinGame = async gameId => {
    const user = this.props.user
    if (!user) {
      alert('Зарегистрируйтесь для того чтобы добавить в избранные')
      return
    }

    const gamblerId = user.get('gamblerId')
    if (gamblerId === null) {
      alert('Зарегистрируйтесь для того чтобы добавить в избранные')
      return
    }

    try {
      const response = await fetch(`/api/games/pin/${gameId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gamblerId }),
      })

      if (response.status === 200) {
        this.addGameToFavorites(gameId)
      } else {
        this.removeGameFromFavorites(gameId)
      }
    } catch (error) {
      console.error('Error pinning the game:', error)
    }
  }

  unpinGame = async gameId => {
    const user = this.props.user
    if (!user) {
      alert('Зарегистрируйтесь для того чтобы удалить из избранных')
      return
    }

    const gamblerId = user.get('gamblerId')
    if (gamblerId === null) {
      alert('Зарегистрируйтесь для того чтобы удалить из избранных')
      return
    }

    try {
      const response = await fetch(`/api/games/un-pin/${gameId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gamblerId }),
      })

      if (response.status === 200) {
        this.removeGameFromFavorites(gameId)
      } else {
        console.error('Failed to unpin the game')
      }
    } catch (error) {
      console.error('Error unpinning the game:', error)
    }
  }

  render() {
    const { games, isLoading, showSignIn, hasMoreGames } = this.state
    return (
      <div className="game-types-page">
        {showSignIn && <SignIn />}
        <Link to="/games">
          <button className="view-all-button">
            <FormattedMessage {...messages.goBackToGames} />
          </button>
        </Link>
        <h1 className="page-title">
          <FormattedMessage {...messages.allGames} />
        </h1>
        <div className="game-list">
          {games.length > 0 ? (
            games.map(game =>
              renderGame(game, this.handleGameClickWrapper, this.state.favoriteGames, this.pinGame, this.unpinGame)
            )
          ) : (
            <div className="no-games-message">Нет игр</div>
          )}
        </div>
        {isLoading && <div>Loading...</div>}
        <br />
        {games.length > 0 && hasMoreGames && !isLoading && (
          <button className="showAll" onClick={this.handleLoadMoreGames}>
            <FormattedMessage {...messages.showMore} />
          </button>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, dispatch) => ({
  user: state.auth.get('user'),
  dispatch,
})

export default withRouter(connect(mapStateToProps)(AllGamesPage))



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/AllGamesPage/AllGames.jsx